import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const Cont = styled.div({
  display: 'flex',
  flexDirection: 'column',
  border: '1px solid rgba(34,36,38,.15)',
  borderRadius: '.28571429rem',
  padding: '0.2rem 0.5rem',
  minHeight: '10rem',
  background:'#fff',

  '.title': {
    fontWeight: 'bold',
    color: `${v.ezMainColor}`
  },

  '.stBold':{
    fontWeight:'bold'
  },

  '.rowI': {
    display:'flex',
    '>div:first-child':{
      flex:3.5,
      marginRight:'0.2rem'
    },
    '>div':{
      flex:1
    }
  }
});
